import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../@core/api/users.service';
import { User } from '../../../@core/data/users';
import { NbRegisterComponent, NbAuthSocialLink, getDeepFromObject, NbAuthResult, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { LenguageService } from '../../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent extends NbRegisterComponent {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: User;
  showPassword = false;

  constructor(
    private auth: AuthService,
    NbAuth: NbAuthService,
    private userService: UserService,
    public language: LenguageService,
    cd: ChangeDetectorRef,
    router: Router) {
    super(NbAuth, {}, cd, router);
  }

  ngOnInit() {

    this.redirectDelay = this.getConfigValue('forms.register.redirectDelay');
    this.showMessages = this.getConfigValue('forms.register.showMessages');
    this.strategy = this.getConfigValue('forms.register.strategy');
    this.socialLinks = this.getConfigValue('forms.login.socialLinks');
  }

  register(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    this.user.lang = this.language.getLang();
    this.user.timezoneOffset = new Date().getTimezoneOffset() * 1000;


    this.userService.signUp(this.user).then(result => {
      this.showMessages = { success: true }
      this.auth.login(this.user).then(() =>{
        this.router.navigateByUrl('home');
      })
    })
      .catch((error) => {
        this.submitted = false;
        this.showMessages = { error: true }
        this.errors = [error]

        this.cd.detectChanges();
      });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  
  getInputType() {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  options: any = {
    strategies: [],
    forms: {
      login: {
        redirectDelay: 500, // delay before redirect after a successful login, while success message is shown to the user
        strategy: 'email',  // provider id key. If you have multiple strategies, or what to use your own
        rememberMe: true,   // whether to show or not the `rememberMe` checkbox
        showMessages: {     // show/not show success/error messages
          success: true,
          error: true,
        },
        socialLinks: [], // social links at the bottom of a page
      },
      register: {
        redirectDelay: 500,
        strategy: 'email',
        showMessages: {
          success: true,
          error: true,
        },
        terms: true,
        socialLinks: [],
      },
      validation: {
        password: {
          required: true,
          minLength: 4,
          maxLength: 50,
        },
        email: {
          required: true,
        },
        terms: {
          required: true
        }
      },
    },
  };
}

